import template from './time_view_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class TimeViewHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class TimeViewHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new TimeViewHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'TimeViewHelp',
	dialog_class: TimeViewHelpPage,
	template: template,
	template_filename: 'translation/dialogs/time_view_help',
	provider: 'ps'
};
